// This is the root reducer file

import { combineReducers } from "redux";
import devicesReducer from "./devicesReducer";
import uiReducer from "./uiReducer";
import uiConfigReducer from "./uiConfigReducer";
import widgetConfigReducer from "./widgetConfigReducer";
import userReducer from "./userReducer";
import sensorHistoReducer from "./sensorHistoReducer";

const appReducer = combineReducers({
  devices: devicesReducer,
  ui: uiReducer,
  uiConfig: uiConfigReducer,
  widgetConfig: widgetConfigReducer,
  user: userReducer,
  sensorHisto: sensorHistoReducer
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_USER") {
    console.log("LOGOUT_USER in root reducer");
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
